// Helpers for the signup acknowledgements (backend#863). The wording and
// versions are served by the backend; these only gate and build the submit.
import type {
  ApplicationSubmitRequest,
  SignupConsentDocument,
} from "@/types/consultant-application";

export const PRIVACY_POLICY_KEY = "privacy_policy";
export const CANDIDATE_CONFIDENTIALITY_KEY = "candidate_confidentiality";

/** True once every served document has been ticked. */
export const allAcknowledged = (
  documents: SignupConsentDocument[] | null | undefined,
  accepted: Record<string, boolean>
): boolean => Boolean(documents?.length) && documents!.every(doc => accepted[doc.document]);

/**
 * The submit body for the acknowledged documents: both flags `true` and the
 * versions the applicant was shown, so the backend can reject stale wording.
 */
export const buildSubmission = (documents: SignupConsentDocument[]): ApplicationSubmitRequest => {
  const version = (key: string) => documents.find(doc => doc.document === key)?.version ?? "";
  return {
    privacy_policy_accepted: true,
    privacy_policy_version: version(PRIVACY_POLICY_KEY),
    candidate_confidentiality_accepted: true,
    candidate_confidentiality_version: version(CANDIDATE_CONFIDENTIALITY_KEY),
  };
};
